/**
 * Google's real sign-in button lives in a cross-origin iframe that cannot be clicked from script,
 * so it is rendered invisibly on top of our styled button and stretched to cover it.
 */
const GOOGLE_BUTTON_MAX_WIDTH = 400;
const GOOGLE_BUTTON_MIN_WIDTH = 200;
const GOOGLE_BUTTON_HEIGHT = 40;

export function fitGoogleButtonOverlay(host) {
  const wrap = host?.parentElement;
  const renderedWidth = Number(host?.dataset.buttonWidth);
  if (!wrap || !renderedWidth) return;
  host.style.transform = `scale(${wrap.offsetWidth / renderedWidth}, ${wrap.offsetHeight / GOOGLE_BUTTON_HEIGHT})`;
}

export function renderGoogleOverlayButton(host) {
  const wrap = host?.parentElement;
  if (!wrap || !window.google?.accounts?.id) return;
  const width = Math.max(GOOGLE_BUTTON_MIN_WIDTH, Math.min(GOOGLE_BUTTON_MAX_WIDTH, Math.round(wrap.offsetWidth)));
  host.innerHTML = '';
  host.dataset.buttonWidth = String(width);
  host.style.width = `${width}px`;
  window.google.accounts.id.renderButton(host, { theme: 'outline', size: 'large', width });
  fitGoogleButtonOverlay(host);
}
